const DAY = 86400000;

/**
 * Ventana de igual duración inmediatamente anterior a [start, end] (inclusive).
 * Ej.: 2026-06-01…2026-06-15 (15 días) → 2026-05-17…2026-05-31.
 * Fechas en UTC para evitar corrimientos de día por timezone.
 */
export function previousPeriod(start, end) {
  const s = Date.parse(`${start}T00:00:00Z`);
  const e = Date.parse(`${end}T00:00:00Z`);
  if (Number.isNaN(s) || Number.isNaN(e) || e < s) return { start, end };
  const lengthDays = Math.round((e - s) / DAY) + 1;
  const prevEnd = s - DAY;
  const prevStart = prevEnd - (lengthDays - 1) * DAY;
  const iso = (ms) => new Date(ms).toISOString().slice(0, 10);
  return { start: iso(prevStart), end: iso(prevEnd) };
}
